// extracted by mini-css-extract-plugin
module.exports = {"footerBox":"_-8Ad-","blockFooter":"vSapo","footerCards":"_3pf8e"};